import { render } from "./CollapseFilters.vue?vue&type=template&id=d8106360"
import script from "./CollapseFilters.vue?vue&type=script&lang=js"
export * from "./CollapseFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__